https://www.ek-studio.co.il/blog-1/categories/%D7%99%D7%95%D7%9D-%D7%A0%D7%99%D7%A9%D7%95%D7%90%D7%99%D7%9F// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});